<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="contracts-page">
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">Umowy</h1>
      </div>
    </div>
    <v-card outlined class="mb-4">
      <v-card-title>{{ $t('contracts.filters') }}</v-card-title>
          <v-card-text>
            <v-row>
              <!-- Department Filter -->
              <v-col cols="12" md="3">
                <v-select
                  v-model="filters.subCompany"
                  :items="subCompanies"
                  :label="$t('contracts.branch')"
                  outlined
                  dense
                  @change="onSubCompanyChange"
                  multiple
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>

              <!-- Week Selector -->
              <v-col cols="12" md="6">
                <v-text-field
                  :label="$t('contracts.week')"
                  v-model="filters.selectedWeek"
                  type="week"
                  outlined
                  dense
                  @change="initialize"
                ></v-text-field>
              </v-col>

              <!-- Settlement Type Filter -->
              <v-col cols="12" md="3">
                <v-select
                  v-model="filters.settlementType"
                  :items="settlementTypes"
                  item-text="text"
                  item-value="value"
                  :label="$t('contracts.settlementType')"
                  outlined
                  dense
                  @change="initialize"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
    <div class="d-flex align-center mb-3" style="gap: 8px;">
      <v-text-field
        v-model="search"
        :label="$t('common.search')"
        outlined dense hide-details
        style="max-width: 320px;"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn small outlined color="success" :loading="exporting" @click="exportCsv">
        <v-icon left small>mdi-file-delimited</v-icon> Eksport CSV
      </v-btn>
      <v-btn small outlined color="info" :loading="exporting" @click="exportPdf">
        <v-icon left small>mdi-file-pdf-box</v-icon> Eksport PDF
      </v-btn>
    </div>

    <v-card outlined>
      <v-tabs v-model="activeTab" background-color="#1F2434" dark slider-color="#5478FF">
        <v-tab>
          <v-icon left small>mdi-file-document-edit</v-icon>
          Zleceniówki
          <v-chip x-small class="ml-2">{{ regularItems.length }}</v-chip>
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-school</v-icon>
          Studenci
          <v-chip x-small class="ml-2" color="#2DCB73" text-color="white">{{ studentItems.length }}</v-chip>
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-domain</v-icon>
          B2B
          <v-chip x-small class="ml-2" color="#F59E0B" text-color="white">{{ b2bItems.length }}</v-chip>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab" style="background: transparent;" touchless>
        <v-tab-item>
          <v-data-table
            :headers="headers" :items="regularItems" :loading="loading"
            :items-per-page="25" :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
            class="elevation-0" dense
          ></v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :headers="headers" :items="studentItems" :loading="loading"
            :items-per-page="25" :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
            class="elevation-0" dense
          >
            <template v-slot:no-data><div class="pa-4 grey--text">Brak studentów w tym okresie.</div></template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :headers="headers" :items="b2bItems" :loading="loading"
            :items-per-page="25" :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
            class="elevation-0" dense
          >
            <template v-slot:no-data><div class="pa-4 grey--text">Brak B2B w tym okresie.</div></template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
  <script>
  import * as dayjs from "dayjs";
  import isoWeek from "dayjs/plugin/isoWeek";
  dayjs.extend(isoWeek);
  import Swal from "sweetalert2";
  import Papa from "papaparse";
  const axios = require("axios");
  export default {
    data() {
      return {
        loading: false,
        exporting: false,
        activeTab: 0,
        search: "",
        options: {
          page: 1,
          itemsPerPage: 10,
        },
        totalItems: 0,
        // Filters
        filters: {
          subCompany: null,
          selectedWeek: dayjs().isoWeekYear() + '-W' + String(dayjs().isoWeek()).padStart(2, '0'),
          settlementType: null,
        },
        // Table Headers
        headers: [
          { text: "Kierowca", value: "driver" },
          { text: "Miesiąc/Rok", value: "date" },
          { text: "Typ ZUS", value: "zusType" },
          { text: "Kwota ZUS", value: "zusAmount" },
          { text: "Kwota Zleceniówki", value: "zleceniowkaAmount" },
        ],
        subCompanies: [{ id: null, name: "WSZYSCY" }],
        settlementTypes: [
          { text: "Wszyscy", value: null },
          { text: "Dzienny", value: "DAILY" },
          { text: "Tygodniowy", value: "WEEKLY" },
          { text: "Co 2 tygodnie", value: "EVERY_2_WEEKS" },
          { text: "Miesięczny", value: "MONTH" },
        ],
        items: [],
      };
    },
    computed: {
      regularItems() {
        return this.items.filter((i) => !i.isStudent && !i.isB2B);
      },
      studentItems() {
        return this.items.filter((i) => i.isStudent);
      },
      b2bItems() {
        return this.items.filter((i) => i.isB2B);
      },
    },
    watch: {
      search: {
        handler() {
          this.initialize();
        },
        deep: true,
      },
    },
    async created() {
      await this.getSubcompanySelect();
      await this.initialize();
    },
    methods: {
      onSubCompanyChange(val) {
        if (val && val.includes(null)) {
          this.filters.subCompany = [];
        }
        this.initialize();
      },
      async toggleLoading(type) {
        const toggle = type;
        localStorage.setItem("loading", toggle);
        window.dispatchEvent(
          new CustomEvent("toggleLoading", {
            detail: {
              loading: localStorage.getItem("loading"),
              overlay: localStorage.getItem("loading"),
            },
          })
        );
      },
      async getSubcompanySelect() {
        await this.toggleLoading(true);
        try {
          const subCompanies = await axios({
            method: "get",
            url: process.env.VUE_APP_ROOT_API + `sub-company`,
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });
          this.subCompanies = [
            { id: null, name: "WSZYSCY" },
            ...subCompanies.data.data.map((it) => {
              return {
                id: it.id,
                name: it.name,
              };
            }),
          ];
        } catch (e) {
          console.log(e);
          Swal.fire("Błąd", e.response.data.message.toString(), "error");
        }
        await this.toggleLoading(false);
      },
      getWeekDates() {
        // Convert week string (e.g., "2024-W01") to start and end dates
        const [yearStr, weekStr] = this.filters.selectedWeek.split('-');
        const week = parseInt(weekStr.replace('W', ''));
        const year = parseInt(yearStr);

        // Find the first day of the year (Jan 4 is always in week 1 ISO)
        const jan4 = dayjs(`${year}-01-04`);
        const dayOfWeek = jan4.day();
        const firstMonday = jan4.subtract((dayOfWeek + 6) % 7, 'day');
        const start = firstMonday.add((week - 1) * 7, 'day');
        const end = start.add(6, 'day');

        return {
          startDate: start.format('YYYY-MM-DD'),
          endDate: end.format('YYYY-MM-DD'),
        };
      },
      formatCurrency(value) {
      return (value / 100).toFixed(2) + ' PLN';
    },
    formatZusType(type) {
      const labels = {
        'B2B': 'B2B',
        'NOT_HIRED_L4': 'Niezatrudniony z L4',
        'NOT_HIRED_NO_L4': 'Niezatrudniony bez L4',
        'HIRED_BELOW_WITH_L4': 'Zatrudniony poniżej z L4',
        'HIRED_BELOW_NO_L4': 'Zatrudniony poniżej bez L4',
        'HIRED_ABOVE': 'Zatrudniony powyżej',
        'STUDENT': 'Student',
        'CONNECTION': 'Podpięcie',
        'UNDER_26_NO_L4': 'Poniżej 26 lat bez L4',
        'UNDER_26_L4': 'Poniżej 26 lat z L4',
      };
      return labels[type] || type || '-';
    },
    async initialize() {
        this.loading = true;
        if (this.search.trim().length > 0) {
          this.options.page = 1;
        }
        try {
          const { startDate, endDate } = this.getWeekDates();
          const response = await axios.get(
            process.env.VUE_APP_ROOT_API +
              `settlements/contracts?take=100000&skip=1&search=${this.search}`,
            {
              params: {
                subCompanyIds: this.filters.subCompany,
                startDate,
                endDate,
                settlementType: this.filters.settlementType || undefined,
              },
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          );
          this.items = response.data.data.result.map((it) => {
            const zus = it.zus && it.zus.length > 0 ? it.zus[0] : null;
            // Student/B2B nie mają rekordu ZUS — bierzemy typ z kierowcy.
            const rawZusType = zus?.zusType || it.driver?.zusType || null;
            const coop = it.cooperationType || it.driver?.cooperationType || null;
            const isB2B = coop === 'B2B_VAT' || coop === 'B2B_NO_VAT';
            const isStudent = !isB2B && rawZusType === 'STUDENT';
            // Data: z ZUS jeśli jest, inaczej miesiąc/rok z daty rozliczenia.
            const d = it.date ? dayjs(it.date) : null;
            return {
              id: it.id,
              driver: it.driver.firstName + " " + it.driver.lastName,
              date: zus
                ? zus.month + '/' + zus.year
                : d
                  ? (d.month() + 1) + '/' + d.year()
                  : '-',
              rawZusType,
              cooperationType: coop,
              isB2B,
              isStudent,
              zusType: this.formatZusType(rawZusType),
              zusAmount: this.formatCurrency(zus?.amount || it.zusDeduction || 0),
              zleceniowkaAmount: this.formatCurrency(it.zleceniowkaAmount || 0),
            };
          });
          this.totalItems = response.data.data.count;
        } catch (e) {
          console.log(e);
          Swal.fire("Błąd", e.response.data.message.toString(), "error");
        }
        this.loading = false;
      },

      buildExportRows() {
        const map = (i, grupa) => ({
          'Grupa': grupa,
          'Kierowca': i.driver,
          'Miesiąc/Rok': i.date,
          'Typ ZUS': i.zusType,
          'Kwota ZUS': i.zusAmount,
          'Kwota Zleceniówki': i.zleceniowkaAmount,
        });
        return [
          ...this.regularItems.map((i) => map(i, 'Zleceniówka')),
          ...this.studentItems.map((i) => map(i, 'Student')),
          ...this.b2bItems.map((i) => map(i, 'B2B')),
        ];
      },

      exportCsv() {
        this.exporting = true;
        try {
          const rows = this.buildExportRows();
          const csv = Papa.unparse(rows, { delimiter: ';' });
          // BOM dla poprawnych polskich znaków w Excelu
          const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `zleceniowki_${this.filters.selectedWeek}.csv`;
          a.click();
          URL.revokeObjectURL(url);
        } catch (e) {
          Swal.fire('Błąd', 'Nie udało się wygenerować CSV', 'error');
        }
        this.exporting = false;
      },

      exportPdf() {
        this.exporting = true;
        try {
          const section = (title, list) => {
            if (!list.length) return `<h3>${title}</h3><p style="color:#666">Brak.</p>`;
            const trs = list
              .map(
                (i) =>
                  `<tr><td>${i.driver}</td><td>${i.date}</td><td>${i.zusType}</td><td style="text-align:right">${i.zusAmount}</td><td style="text-align:right">${i.zleceniowkaAmount}</td></tr>`,
              )
              .join('');
            return `<h3>${title} (${list.length})</h3>
              <table>
                <thead><tr><th>Kierowca</th><th>Miesiąc/Rok</th><th>Typ ZUS</th><th>Kwota ZUS</th><th>Kwota Zleceniówki</th></tr></thead>
                <tbody>${trs}</tbody>
              </table>`;
          };
          const html = `<!DOCTYPE html><html><head><meta charset="utf-8">
            <title>Zleceniówki ${this.filters.selectedWeek}</title>
            <style>
              body{font-family:-apple-system,Arial,sans-serif;padding:24px;color:#111}
              h1{font-size:18px;margin:0 0 4px}
              .sub{color:#666;font-size:12px;margin:0 0 18px}
              h3{font-size:14px;margin:20px 0 6px;border-bottom:2px solid #2C5FF6;padding-bottom:4px}
              table{width:100%;border-collapse:collapse;font-size:11px;margin-bottom:10px}
              th,td{border:1px solid #ddd;padding:5px 8px;text-align:left}
              th{background:#0F1923;color:#fff}
              tr:nth-child(even) td{background:#f7f7f7}
              @media print{@page{margin:1.5cm}}
            </style></head><body>
            <h1>Zleceniówki</h1>
            <p class="sub">Tydzień ${this.filters.selectedWeek} · wygenerowano ${dayjs().format('DD.MM.YYYY HH:mm')}</p>
            ${section('Zleceniówki', this.regularItems)}
            ${section('Studenci', this.studentItems)}
            ${section('B2B', this.b2bItems)}
            </body></html>`;
          const w = window.open('', '_blank');
          if (!w) {
            Swal.fire('Uwaga', 'Odblokuj wyskakujące okienka żeby wygenerować PDF', 'warning');
            this.exporting = false;
            return;
          }
          w.document.write(html);
          w.document.close();
          w.focus();
          setTimeout(() => { w.print(); }, 400);
        } catch (e) {
          Swal.fire('Błąd', 'Nie udało się wygenerować PDF', 'error');
        }
        this.exporting = false;
      },
    }
  };
  </script>
<style scoped>
.contracts-page { background: #181C28; min-height: calc(100vh - 56px); padding: 16px 16px 40px; margin: -24px; color: #fff; }
.page-header { padding: 4px 4px 18px; }
.page-eyebrow { font-size: 12px; color: #6E7691; font-weight: 500; text-transform: capitalize; }
.page-title { font-size: 22px; font-weight: 800; color: #fff; margin: 2px 0 0; letter-spacing: -0.02em; }

.contracts-page >>> .v-card { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; box-shadow: none !important; color: #fff !important; }
.contracts-page >>> .v-card .v-card__title { color: #fff !important; padding: 16px 20px 8px !important; font-weight: 700 !important; font-size: 15px !important; }
.contracts-page >>> .v-text-field--outlined fieldset, .contracts-page >>> .v-select--outlined fieldset { border-color: rgba(255,255,255,0.1) !important; }
.contracts-page >>> .v-text-field--outlined .v-input__slot, .contracts-page >>> .v-select--outlined .v-input__slot { background: #181C28 !important; border-radius: 12px !important; }
.contracts-page >>> .v-label { color: #6E7691 !important; }
.contracts-page >>> .v-text-field input, .contracts-page >>> .v-select__selection { color: #fff !important; }
.contracts-page >>> .v-text-field:not(.v-text-field--outlined) input { color: #fff !important; }
.contracts-page >>> .v-text-field:not(.v-text-field--outlined) > .v-input__control > .v-input__slot::before { border-color: rgba(255,255,255,0.16) !important; }
.contracts-page >>> .v-input__prepend-inner .v-icon, .contracts-page >>> .v-input__append-inner .v-icon { color: #6E7691 !important; }
.contracts-page >>> .v-data-table { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; color: #fff !important; box-shadow: none !important; }
.contracts-page >>> .v-data-table thead tr th { background: #1F2434 !important; color: #6E7691 !important; font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid rgba(255,255,255,0.06) !important; }
.contracts-page >>> .v-data-table tbody tr { background: #232838 !important; }
.contracts-page >>> .v-data-table tbody tr:hover { background: #2A3042 !important; }
.contracts-page >>> .v-data-table tbody tr td { color: #fff !important; border-bottom: 1px solid rgba(255,255,255,0.04) !important; }
.contracts-page >>> .v-data-footer { background: #1F2434 !important; color: #B0BEC5 !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.contracts-page >>> .v-toolbar { background: transparent !important; color: #fff !important; }
.contracts-page >>> .v-btn:not(.v-btn--icon) { border-radius: 10px !important; text-transform: none !important; font-weight: 600 !important; }
.contracts-page >>> .v-chip { border-radius: 999px !important; font-weight: 700 !important; }
.contracts-page >>> .v-divider { border-color: rgba(255,255,255,0.06) !important; }
.contracts-page >>> .v-progress-linear { background: rgba(255,255,255,0.06) !important; }
.contracts-page >>> .v-dialog .v-card { background: #232838 !important; }
</style>
  